import React from "react";
import styles from "./styles.module.scss";
import classNames from "classnames";

interface ILoaderProps {
  progress: number; 
}

const ProgressLoader: React.FC<ILoaderProps> = ({ progress }) => {
  return (
    <div className={classNames(styles.loaderContainer, 'progressLoader')}>
      <div className={styles.loaderBar}>
        <div
          className={styles.loaderProgress}
          style={{ width: `${progress}%` }}
        />
        <div className={styles.loaderBackground}>

        </div>
        <div className={styles.circleLeft}></div>
        <div className={styles.circleRight}></div>
      </div>
    </div>
  );
};

export default ProgressLoader;